<template>
    <div class="block-account p-3 pb-5 mt-1 o">
        <div class="d-flex align-items-center">
            <div class="position-relative">
                <img :src="`${publicPath}/img/gep/${item.userType}.svg`" width="50px">
                <img :src="`${publicPath}/img/gep/icon/${status.toLocaleLowerCase()}.svg`" width="20px" class="position-absolute right-0 bottom-0" style="transform:translate(40%,40%)">
            </div>
            <div class="px-3 d-flex flex-column">
                <div class="fz-20 fw-700">{{ item.information?item.information.enName:'-' }}</div>
                <div class="fz-14 fw-400 d-flex align-items-center">
                    <span>{{ sub_account.bankNo?sub_account.bankNo:'-' }}</span>
                    <img :src="`${publicPath}/img/gep/icon/copy.svg`" width="20px" class="mx-2" style="cursor: pointer;" alt="copy" @click="onCopy(sub_account.bankNo?sub_account.bankNo:'-')">
                </div>
            </div>
            <button v-if="status == 'Approved'" class="btn btn-primary view-sub-account ml-auto" @click=handleViewSubAccount(item.id,item.userType)>{{ $t('View Account Details') }}</button>
            <button v-if="status == 'Rejected'" class="btn bg-green text-white view-sub-account ml-auto" @click=gotoResubmit(item.id,item.userType)>{{ $t('Resubmit Form') }}</button>
            
        </div>
        <hr v-if="item.have_sub_account">
        <div v-if="item.have_sub_account" class="d-flex mb-3">
            <span class="fz-16 fw-500 text-grey7">{{$t('Account Balance')}}</span>
            <span class="ml-auto fz-16 fw-600 d-flex">
                <ToggleBalance 
                    v-for="ccy in default_currency"
                    :userNo="item.userNo" 
                    :currency="ccy"
                    :key="ccy">
                </ToggleBalance>
            </span>
        </div>

        <div class="mb-3 text-right position-relative" v-if="item.have_sub_account">
            <span class="fz-14 fw-500">{{$t('See all currencies')}}</span><a @click.stop.prevent="changeVisible" class="text-blue fz-14 fw-500 ml-2">{{ $t('See More') }}</a>
            <div class="position-absolute togle-currencies" :class="is_visible === true?'d-block':'d-none'">
                <span class="fz-12 fw-400">{{ $t('All Currencies Balance:') }}</span>
                <table class="fz-14">
                    <tr class="fw-500">
                        <td>{{ $t('Currency') }}</td>
                        <td>{{ $t('Balance') }}</td>
                        <td>{{ $t('Set Visible') }}</td>
                    </tr>
                    <RowBalance v-for="(data,index) in balance" 
                        :userNo="item.userNo" 
                        :default_currency="default_currency"
                        :currency="data" 
                        :key="index" 
                        :index="index"
                        @set-balance="setBalance"
                        @remove-balance="removeBalance"
                        :ref="'balance_'+data">
                    </RowBalance>
                </table>
            </div>
        </div>
        <hr>
        <div class="d-flex mb-2">
            <span class="fz-16 fw-500 text-grey7">{{$t(item.userType == 1?'Type':'Company Type')}}</span>
            <span class="ml-auto fz-16 fw-600">{{ item.txt_userType }}</span>
        </div>
        <div class="d-flex mb-2">
            <span class="fz-16 fw-500 text-grey7">{{$t('Account Bank Name')}}</span>
            <span class="ml-auto fz-16 fw-600">{{ sub_account.bankAccountName?sub_account.bankAccountName:'-' }}</span>
        </div>
        <div class="d-flex mb-2">
            <span class="fz-16 fw-500 text-grey7">{{$t('Merchant Number')}}</span>
            <span class="ml-auto fz-16 fw-600">{{ item.userNo }}</span>
        </div>
        <div class="d-flex mb-2">
            <span class="fz-16 fw-500 text-grey7">{{ $t('Status') }}</span>
            <span class="ml-auto fz-16 fw-600 text-right" :class="'text-'+status.toLocaleLowerCase()" style="max-width: 330px;">{{ $t(status) }}<span class="text-grey9 fw-300 fz-12 mx-2" v-if="item.remarks">|</span> {{ item.remarks }}</span>

        </div>
        <div class="d-flex mb-2 p">
            <span class="fz-16 fw-500 text-grey7">{{ $t('Created At') }}</span>
            <span class="ml-auto fz-16 fw-600" v-html="getDate(item.created_at)"></span>
        </div>
    </div>
</template>

<script>
    import CreateAccount from '@/services/CreateAccount';
    import RowBalance from '@/components/RowBalance';
    import ToggleBalance from '@/components/ToggleBalance';
  
  const STATUS = {
    0:"Draft",
    1:"Pending",
    2:"Approved",
    3:"Rejected"
  };
  
  export default {
    data() {
      return {
        publicPath: process.env.BASE_URL !== '/' ? process.env.BASE_URL : '',
        balance:{},
        isTooltip:false,
        default_currency:'',
        sub_account:{},
        is_visible:false,
        status:'',
      };
    },
    props:['item'],
    components:{
        RowBalance,
        ToggleBalance
    },
    methods: {
        getMessage: function (key) {
          return this.$t(key)
        },
        onCopy(text){
            navigator.clipboard.writeText(text);
            this.$notify({
                type: 'success',
                text: this.getMessage('Copy')
            })
        },
        getDate(date){
            let split = date.split(" ");
            return split[0]+" <span class='text-grey9 fw-300 fz-12 mx-2'>|</span> "+split[1];
        },
        gotoResubmit(id,userType){
            let path = '';
            if(userType==2){
                path = 'china-basic-information';
            }
            else if(userType==5){
                path = 'international-company-information';
            }
            else{
                path = 'hongkong-basic-information';
            }
            this.$router.push({ 
                path: '/'+path
            });
        },
        toggleTooltip(){
            this.isTooltip = !this.isTooltip;
        },
        setBalance(price,currency){
            if(!this.default_currency.includes(currency)){
                this.default_currency.push(currency);
            }
            localStorage.setItem("ccy",JSON.stringify(this.default_currency));
        },
        removeBalance(price,currency){
            this.default_currency.splice(this.default_currency.indexOf(currency),1);
            localStorage.setItem("ccy",JSON.stringify(this.default_currency));
        },
        changeVisible(){
            this.is_visible = !this.is_visible;
        },
        getSubAccount(){
            let self = this;
            CreateAccount.listSubAccount({
                start:0,
                length:-1,
                search:{value:this.item.userNo}
            }).then((response)=>{
                if (response.status == 200) {
                    if(response.data.data.length>0){
                        self.sub_account = response.data.data[0];
                        self.status = STATUS[this.sub_account.status];
                        self.balance = this.sub_account['currency'].split(",");
                    }
                    else{
                        self.status = this.item.status!=2?STATUS[this.item.status]:STATUS[1];
                    }
                }
            });
        },
        handleViewSubAccount(){
            this.$emit('viewDetail',this.sub_account);
        },
        handleSubAccount(data){
            this.$emit('sub-account',data);
        }
    },
    mounted() {
        let self = this;
        this.$nextTick(() => {
            let selected_list;

            try{
                selected_list = JSON.parse(localStorage.getItem("ccy"));
            }catch(e){
                selected_list = ['HKD'];
            }

            if(!Array.isArray(selected_list) || selected_list.length==0){
                selected_list = ['HKD'];
            }

            this.default_currency = selected_list;
            self.getSubAccount();
        });
    },
    destroyed() {
      
    },
  };
  </script>
  
<style>
.btn-tooltip{
    cursor: pointer;
}
.tooltip-info2{
    bottom: 0;
    top: unset;
    background-color: #1F2A37;
    min-width: 225px;
    word-break: break-all;
    padding: 10px;
    border-radius: 4px;
    position: absolute;
    -webkit-transform: translateY(100%);
    transform: translateY(100%);
    text-align: center;
    right: 0;
}
.tooltip-info2::after{
    content: ' ';
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #1f2a37;
    position: absolute;
    top: -7px;
    right: 7px;
    transform: rotate(180deg);
}
.tooltip-info2 .title{
  color: #fff;
}
.tooltip-info2 .desc{
  color: #9CA3AF;
}
.block-account{
    background: #F8F9FA;
    border-radius: 8px;
}
.togle-currencies{
    background: #fff;
    border-radius: 8px;
    border: 1px solid #D1D4D7;
    text-align: center;
    padding: 10px;
    width: 100%;
    max-width: 320px;
    right: 0;
    bottom: 0;
    transform: translateY(100%);
}
.togle-currencies table{
    width: 100%;
}
.togle-currencies .switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.togle-currencies .switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.togle-currencies .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.togle-currencies .slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

.togle-currencies input:checked + .slider {
  background-color: #2196F3;
}

.togle-currencies input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

.togle-currencies input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.togle-currencies .slider.round {
  border-radius: 34px;
}

.togle-currencies .slider.round:before {
  border-radius: 50%;
}
a{
    cursor: pointer;
}
</style>